export default __webpack_public_path__ + "img/BB_NB.ac6f13149b45808e3970d9a74e37c924.jpg";